import bilAPI from "./api";

// All three are public — the caller has no session yet, which is the point.
export const getFederatedProviders = ({ signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/auth/federated/providers/`, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// Resolves `{ authorization_url, state }`. The state is echoed back by the
// provider and re-checked here before the code is spent, so a callback the user
// never initiated is discarded without a round-trip.
export const startFederatedLogin = ({ slug, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/auth/federated/${encodeURIComponent(slug)}/start/`, null, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// Resolves `{ access, refresh }` — Telos's own tokens. The provider's token
// never reaches the browser and is never a Telos API credential.
export const completeFederatedLogin = ({ slug, code, state, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(
          `/auth/federated/${encodeURIComponent(slug)}/callback/`,
          { code, state },
          { signal },
        )
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// Asked BEFORE the tokens are cleared — the endpoint is authenticated, and the
// answer depends on how this person signed in. Resolves `{ logout_url }`, null
// for a password login or a provider with no logout endpoint.
export const getFederatedLogoutUrl = ({ signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/auth/federated/logout-url/`, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};
